import type { AxiosResponse } from "axios";

import config from "@/common/config";
import type SearchRequestMethods from "@/common/search-request-helper";
import type { SearchResponse } from "@/types/search";

import ApiService from "./api.service";
import type { ApiResponse } from "./types";

export default {
  VERSION: config.api.versions.v2,

  search(
    query: string,
    searchRequestMethods: SearchRequestMethods,
    referrer: string | undefined = undefined
  ): Promise<AxiosResponse<ApiResponse<SearchResponse>>> {
    const data = {
      query,
      methods: searchRequestMethods.get(),
      referrer
    };

    return ApiService.post("/search", data, this.VERSION);
  }
};
